module.exports = __webpack_public_path__ + "img/CompScope_Bright_04.d9d74956.png";